module.exports = __webpack_public_path__ + "img/swift-plus-white.92d52ce2.png";